import { Injectable } from '@angular/core';

import {BaseService} from "app/views/base.service";
import {HttpClient} from "@angular/common/http";


@Injectable()
export class PeriodService extends BaseService {
	public period: string = 'day';

	constructor(public http: HttpClient) {
		super(http);
	}
}
